import { render } from "./PackageDocumentEditDialog.vue?vue&type=template&id=306f9f06"
import script from "./PackageDocumentEditDialog.vue?vue&type=script&lang=js"
export * from "./PackageDocumentEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__